<script setup lang="ts">
import { computed } from 'vue';
import type { InquiryValidation } from '@/javascripts/composables/inquiry/validation';
import Inquiry from '@/javascripts/utils/inquiry';
import SlideIndicator from './slide_indicator.vue';

const emit = defineEmits(['next', 'back']);

const props = defineProps<{
  inquiry: Inquiry,
  inquiryValidation: InquiryValidation,
  currentSlideIndex: number,
}>();

const invalid = computed(() => 
  props.inquiryValidation.lastName.$invalid ||
  props.inquiryValidation.firstName.$invalid || 
  props.inquiryValidation.lastNameKana.$invalid || 
  props.inquiryValidation.firstNameKana.$invalid || 
  props.inquiryValidation.phone.$invalid ||
  props.inquiryValidation.callAcceptance.$invalid
);

/** お名前のバリデーションエラー(姓優先) */
const nameValidationErrors = computed(
  () => props.inquiryValidation.lastName.$error ? props.inquiryValidation.lastName.$errors : props.inquiryValidation.firstName.$errors
);

/** ふりがなのバリデーションメッセージ(姓優先) */
const kanaValidationErrors = computed(
  () => props.inquiryValidation.lastNameKana.$error ? props.inquiryValidation.lastNameKana.$errors : props.inquiryValidation.firstNameKana.$errors
);
</script>

<template>
  <div class="inner_content inner_step">
    <div class="main_content step_content">
      <SlideIndicator :current-slide-index="currentSlideIndex" />
      <h2>お名前と電話番号をご入力ください</h2>
      <div class="box_form">
        <table>
          <tr>
            <th>
              名前
            </th>
            <td class="input_m">
              <input
                id="last_name"
                v-model="inquiry.lastName"
                required
                class="name"
                name="last_name"
                placeholder="山田"
                type="text"
              >
              <input
                id="name"
                v-model="inquiry.firstName"
                required
                class="shindan-input-text"
                name="first_name"
                placeholder="太郎"
                type="text"
              >
            </td>
          </tr>
          <tr>
            <th class="view_pc" />
            <td class="form_error">
              <p
                v-for="(error, index) in nameValidationErrors"
                :key="index"
                class="form_errormessage"
              >
                {{ error.$message }}
              </p>
            </td>
          </tr>
          <tr>
            <th>
              ふりがな
            </th>
            <td class="input_m">
              <input
                id="first_name_kana"
                v-model="inquiry.firstNameKana"
                required
                class="name"
                name="first_name_kana"
                placeholder="やまだ"
                type="text"
              >
              <input
                id="last_name_kana"
                v-model="inquiry.lastNameKana"
                required
                class="name"
                name="last_name_kana"
                placeholder="たろう"
                type="text"
              >
            </td>
          </tr>
          <tr>
            <th class="view_pc" />
            <td class="form_error">
              <p
                v-for="(error, index) in kanaValidationErrors"
                :key="index"
                class="form_errormessage"
              >
                {{ error.$message }}
              </p>
            </td>
          </tr>
          <tr>
            <th>
              電話番号
            </th>
            <td class="input_l">
              <input
                v-model="inquiry.phone"
                class="tel"
                required
                name="phone"
                placeholder="例：09011111111"
                inputmode="numeric"
                pattern="\d*"
                type="tel"
              >
            </td>
          </tr>
          <tr>
            <th class="view_pc" />
            <td class="form_error">
              <p
                v-for="(error, index) in inquiryValidation.phone.$errors"
                :key="index"
                class="form_errormessage"
              >
                {{ error.$message }}
              </p>
            </td>
          </tr>
          <tr class="box_input box_input_btn">
            <th class="input_tit">
              電話でのご連絡
            </th>
            <td class="inner_input_btn">
              <div class="step_btn">
                <label
                  class="shindan_radio_label"
                  for="call-01"
                >
                  <input
                    id="call-01"
                    v-model="inquiry.callAcceptance"
                    :value="true"
                    class="shindan_radio_input"
                    name="call_acceptance_flag"
                    type="radio"
                  >
                  <p>可</p>
                </label>
              </div>
              <div class="step_btn">
                <label 
                  class="shindan_radio_label"
                  for="call-02"
                >
                  <input
                    id="call-02"
                    v-model="inquiry.callAcceptance"
                    :value="false"
                    class="shindan_radio_input"
                    name="call_acceptance_flag"
                    type="radio"
                  >
                  <p>不可</p>
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <th class="view_pc" />
            <td class="form_error">
              <p
                v-for="(error, index) in inquiryValidation.callAcceptance.$errors"
                :key="index"
                class="form_errormessage"
              >
                {{ error.$message }}
              </p>
            </td>
          </tr>
        </table>
      </div>
      <div class="box_btn_nextback">
        <div class="btn_back">
          <button @click.once="emit('back')">
            <span>戻る</span>
          </button>
        </div>
        <div class="btn_next input_btn">
          <button
            id="ph_next_1"
            :disabled="invalid"
            class="shindan_nextbtn_area"
            :class="{
              'shindan_next_btn_off': invalid,
              'shindan_next_btn_on': !invalid
            }"
            @click.once="$emit('next')"
          >
            <span>次へ</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
